import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

export interface StatementVoteBudget {
  freeTotal: bigint;
  freeAvailable: bigint;
  stakedTotal: bigint;
  stakedAvailable: bigint;
  isLoading: boolean;
  isError: boolean;
}

const toBig = (v: string | undefined): bigint => {
  try {
    return v ? BigInt(v) : 0n;
  } catch {
    return 0n;
  }
};

export const useStatementVoteBudget = (
  id: string,
  enabled: boolean,
): StatementVoteBudget => {
  const q = useQuery({
    queryKey: ["get", "/statements/{id}/votes/budget", id],
    enabled,
    queryFn: async () => {
      const { data, error } = await (
        fetchClient as unknown as {
          GET: (
            path: "/statements/{id}/votes/budget",
            init: { params: { path: { id: string } } },
          ) => Promise<{
            data?: { data?: Record<string, string> };
            error?: unknown;
          }>;
        }
      ).GET("/statements/{id}/votes/budget", {
        params: { path: { id } },
      });
      if (error) throw error;
      return data;
    },
  });
  // Global response wrapper nests under .data.data (same as votes/mine unwrap).
  const d = (q.data as { data?: Record<string, string> } | undefined)?.data;
  return {
    freeTotal: toBig(d?.freeTotal),
    freeAvailable: toBig(d?.freeAvailable),
    stakedTotal: toBig(d?.stakedTotal),
    stakedAvailable: toBig(d?.stakedAvailable),
    isLoading: q.isLoading,
    isError: q.isError,
  };
};
